import React, { useState } from 'react';
import NotificationSettings from '../components/NotificationSettings';
import { NotificationData } from '../components/NotificationBadge';
import './NotificationTestPage.css';

const NotificationTestPage: React.FC = () => {
  const [testMessage, setTestMessage] = useState({
    title: 'Test Notification',
    body: 'Đây là thông báo test từ KILOBA Hub!',
    icon: '/icons/icon-192x192.png'
  });

  const sendTestNotification = () => {
    // Tạo test notification data
    const notificationData: NotificationData = {
      id: Date.now().toString(),
      title: testMessage.title,
      body: testMessage.body,
      icon: testMessage.icon,
      timestamp: Date.now(),
      data: {
        click_action: '/notifications',
        test: true
      }
    };

    // Dispatch custom event để hiển thị notification
    const event = new CustomEvent('notification-received', {
      detail: notificationData
    });
    window.dispatchEvent(event);
  };

  const sendServiceWorkerNotification = () => {
    if ('serviceWorker' in navigator && 'Notification' in window) {
      if (Notification.permission === 'granted') {
        navigator.serviceWorker.ready.then((registration) => {
          registration.showNotification(testMessage.title, {
            body: testMessage.body,
            icon: testMessage.icon,
            badge: '/icons/icon-72x72.png',
            tag: 'test-notification',
            data: {
              click_action: '/notifications',
              test: true
            },
            requireInteraction: true
          } as any); // Type assertion to bypass TypeScript limitation
        });
      } else {
        alert('Vui lòng bật notification permission trước!');
      }
    }
  };

  const requestNotificationPermission = async () => {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      console.log('Notification permission:', permission);
    }
  };

  return (
    <div className="notification-test-page">
      <div className="page-header">
        <h1>🔔 Test Firebase Notifications</h1>
        <p>Trang test và cài đặt thông báo Firebase</p>
      </div>

      <div className="notification-sections">
        
        {/* Settings Section */}
        <section className="settings-section">
          <h2>Cài đặt thông báo</h2>
          <NotificationSettings />
        </section>

        {/* Test Section */}
        <section className="test-section">
          <h2>Test thông báo</h2>
          
          <div className="test-form">
            <div className="form-group">
              <label htmlFor="test-title">Tiêu đề:</label>
              <input
                id="test-title"
                type="text"
                value={testMessage.title}
                onChange={(e) => setTestMessage({...testMessage, title: e.target.value})}
                className="test-input"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="test-body">Nội dung:</label>
              <textarea
                id="test-body"
                value={testMessage.body}
                onChange={(e) => setTestMessage({...testMessage, body: e.target.value})}
                className="test-textarea"
                rows={3}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="test-icon">Icon URL:</label>
              <input
                id="test-icon"
                type="text"
                value={testMessage.icon}
                onChange={(e) => setTestMessage({...testMessage, icon: e.target.value})}
                className="test-input"
              />
            </div>
          </div>

          <div className="test-buttons">
            <button
              className="test-btn test-btn-primary"
              onClick={sendTestNotification}
            >
              🔔 Test Notification Badge
            </button>
            
            <button
              className="test-btn test-btn-secondary"
              onClick={sendServiceWorkerNotification}
            >
              📱 Test Service Worker Notification
            </button>
            
            <button
              className="test-btn test-btn-info"
              onClick={requestNotificationPermission}
            >
              🔓 Request Permission
            </button>
          </div>
        </section>

        {/* Status Section */}
        <section className="status-section">
          <h2>Trạng thái hệ thống</h2>
          
          <div className="status-grid">
            <div className="status-item">
              <span className="status-label">Notification API:</span>
              <span className={`status-value ${('Notification' in window) ? 'supported' : 'unsupported'}`}>
                {('Notification' in window) ? '✅ Supported' : '❌ Not Supported'}
              </span>
            </div>
            
            <div className="status-item">
              <span className="status-label">Service Worker:</span>
              <span className={`status-value ${('serviceWorker' in navigator) ? 'supported' : 'unsupported'}`}>
                {('serviceWorker' in navigator) ? '✅ Supported' : '❌ Not Supported'}
              </span>
            </div>
            
            <div className="status-item">
              <span className="status-label">Permission:</span>
              <span className={`status-value permission-${Notification.permission}`}>
                {Notification.permission === 'granted' ? '✅ Granted' : 
                 Notification.permission === 'denied' ? '❌ Denied' : 
                 '⚠️ Default'}
              </span>
            </div>
            
            <div className="status-item">
              <span className="status-label">Firebase Messaging:</span>
              <span className="status-value supported">
                ✅ Integrated
              </span>
            </div>
          </div>
        </section>

        {/* Instructions Section */}
        <section className="instructions-section">
          <h2>Hướng dẫn test</h2>
          
          <div className="instructions">
            <ol>
              <li>
                <strong>Bật notification permission:</strong> Click "Request Permission" hoặc bật trong settings
              </li>
              <li>
                <strong>Test notification badge:</strong> Click "Test Notification Badge" để xem notification trong app
              </li>
              <li>
                <strong>Test service worker:</strong> Click "Test Service Worker Notification" để xem system notification
              </li>
              <li>
                <strong>Customize message:</strong> Thay đổi title, body, icon để test các loại notification khác nhau
              </li>
              <li>
                <strong>Check Firebase Console:</strong> Gửi notification từ Firebase Console để test push notification
              </li>
            </ol>
          </div>
        </section>

      </div>
    </div>
  );
};

export default NotificationTestPage;
